import * as React from "react";
import {
  TextInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  useRecordContext,
  required,
} from "react-admin";
import Transformer from "../../../common/Transformer";
import { AttributeEditComponent } from "./";
import { AttributeTypeEnum, AttributeOptionTypeEnum, AttributeMetaTypeEnum } from "../../../common/enum";
import { Edit, TabbedForm, FormTab } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";
import { CustomField } from "../CustomField";

export const AttributeEdit = (props) => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "type", "createdAt", "updatedAt"],
      update: {
        attributeSets: data.attribute_sets?.map(
          (op) => (op.id),
          data
        ),
        options: data.options?.map(
          (op) => ({ attribute: data.id, id: op.id, value: op.value, label: op.label }),
          data
        ),
      },
    });

    return data;
  };

  return (
    <Edit
      component={AttributeEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <EditForm {...props} />
    </Edit>
  );
};

const EditForm = (props) => {
  const record = useRecordContext(props);

  const isOptionType = AttributeOptionTypeEnum.includes(record.type);

  return (
    <TabbedForm>
      <FormTab label="General" name="general">
        <Grid container item sm={6} rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="code" validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12}>
            <SelectInput
              source="type"
              choices={AttributeTypeEnum}
              validate={required()}
              disabled
            />
          </Grid>
        </Grid>
      </FormTab>
      {isOptionType && (
        <FormTab label="Options" name="options">
          <Grid container rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} lg={6}>
              <ArrayInput source="options">
                <SimpleFormIterator disableReordering inline>
                  <TextInput source="label" />
                  <TextInput source="value" required/>
                </SimpleFormIterator>
              </ArrayInput>
            </Grid>
          </Grid>
        </FormTab>
      )}
      {AttributeMetaTypeEnum.hasOwnProperty(record.type) && (
        <FormTab label="Meta" name="meta">
          <Grid container item sm={6} rowSpacing={1} columnSpacing={2}>
            {AttributeMetaTypeEnum[record.type].map((metaOption, key) => (
              <Grid item sm={12} key={`meta-${metaOption.code}-${key}`}>
                <CustomField source={`meta.${metaOption.code}`} attribute={metaOption} />
              </Grid>
            ))}
          </Grid>
        </FormTab>
      )}
    </TabbedForm>
  );
};
